import { useState, useEffect } from 'react';
import Axios from 'axios';
import isEmail from 'validator/lib/isEmail';

export const useSnowReportSignup = ({
  endpoint,
  countrySelectionErrorMessage
}) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [emailAddress, setEmailAddress] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [country, setCountry] = useState(null);
  const [isValidCountry, setIsValidCountry] = useState(null);
  const [expressConsent, setExpressConsent] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(null);
  const [dropdownErrorMessage, setDropdownErrorMessage] = useState('');

  useEffect(() => {
    if (isValidEmail && isValidCountry && expressConsent) {
      setIsSubmitButtonDisabled(false);
    } else {
      setIsSubmitButtonDisabled(true);
    }
  }, [isValidEmail, isValidCountry, expressConsent]);

  const useFetchData = async () => {
    if (isValidEmail && isValidCountry && expressConsent) {
      try {
        const { data } = await Axios({
          method: 'POST',
          url: endpoint,
          data: {
            emailAddress,
            country,
            expressConsent,
            subscriptions
          }
        });
        const { passedValidation, errors } = data;
        setIsValid(passedValidation);
        if (errors.length > 0) setErrorMessage(errors[0].message);
      } catch (error) {
        console.error();
      }
    }
  };

  const handleSelectedOptions = value => {
    const selectedOptions = [...subscriptions];

    if (selectedOptions.includes(value)) {
      selectedOptions.splice(selectedOptions.indexOf(value), 1);
    } else {
      selectedOptions.push(value);
    }

    setSubscriptions(selectedOptions);
  };

  const handleDropdownOptions = option => {
    setIsFirstLoad(false);
    if (option.value) {
      setDropdownErrorMessage('');
      setIsValidCountry(true);
      setCountry(option.value);
    } else {
      setDropdownErrorMessage(countrySelectionErrorMessage);
      setIsValidCountry(false);
      setCountry(null);
    }
  };

  const handleEmailValue = value => {
    setIsFirstLoad(false);
    setEmailAddress(value);
    setIsValidEmail(isEmail(value));
  };

  const handleResetForm = countryOptions => {
    setIsFirstLoad(true);
    setIsValid(false);
    setEmailAddress('');
    setIsValidEmail(false);
    setSubscriptions([]);
    setCountry(countryOptions.options[0]);
    setExpressConsent(false);
    setIsSubmitButtonDisabled(false);
  };

  return {
    useFetchData,
    handleDropdownOptions,
    handleEmailValue,
    handleSelectedOptions,
    handleResetForm,
    setIsSubmitButtonDisabled,
    setExpressConsent,
    isValidCountry,
    isValidEmail,
    emailAddress,
    expressConsent,
    isFirstLoad,
    isValid,
    errorMessage,
    isSubmitButtonDisabled,
    dropdownErrorMessage,
    subscriptions,
    country
  };
};
